import React from 'react';
import { connect } from 'react-redux';

import { PromoPageContainer } from 'components/no-auth/common/PromoPageContainer/PromoPageContainer';
import { PromoSectionContainer } from 'components/no-auth/common/PromoSectionContainer';
import HeadingSection from 'components/no-auth/common/sections/HeadingSection';
import { HeroSection } from 'components/no-auth/common/sections/HeroSection';
import { ListingTilesSection } from 'components/no-auth/common/sections/ListingTilesSection';
import NotAuthBasePage from 'components/no-auth/NotAuthBasePage';

const LeadershipTeamPage = (props) => {
    return (
        <PromoPageContainer bgColor={'eggshell03'} noIndent>
            {props.heroTitle && <HeroSection data={props.heroData} title={props.heroTitle} />}
            <PromoSectionContainer>
                {props.directorTitle && <HeadingSection description={props.directorDescription} title={props.directorTitle} />}
                {props.directors && <ListingTilesSection data={props.directors} />}
                {props.teamTitle && <HeadingSection title={props.teamTitle} />}
                {props.team && <ListingTilesSection data={props.team} />}
            </PromoSectionContainer>
        </PromoPageContainer>
    );
};
const mapStateToProps = (state) => {
    return {
        heroData: state.extra?.strapiApi?.hero_block,
        heroTitle: state.extra?.strapiApi?.hero_block?.title,

        directorTitle: state.extra?.strapiApi?.directors_headline?.title,
        directorDescription: state.extra?.strapiApi?.directors_headline?.description,
        directors: state.extra?.strapiApi?.director_cards,

        teamTitle: state.extra?.strapiApi?.team_headline?.title,
        team: state.extra?.strapiApi?.team_cards,
    };
};
export default connect(mapStateToProps)(NotAuthBasePage(LeadershipTeamPage));
